import { render } from "./NetworksalesHistory.vue?vue&type=template&id=cf5f103e"
import script from "./NetworksalesHistory.vue?vue&type=script&lang=ts"
export * from "./NetworksalesHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script